"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatInsuranceBilling = void 0;
const formatInsuranceBilling = (payload) => {
    const billings = payload.data.map((item) => ({
        period: `${item.year}-${String(item.month).padStart(2, '0')}-01T12:00:00`,
        price_cents: item.booking_insurances_fee_total,
        total_fee: item.insurances_total_cents,
        total_price_with_fee: item.booking_insurances_fee_total + item.insurances_total_cents,
    }));
    return billings;
};
exports.formatInsuranceBilling = formatInsuranceBilling;
//# sourceMappingURL=index.js.map